export const config = {
    site_title: "Progitek",
    api_base_url: "https://progitek.no",
    copyright_url:"https://progitek.no",
    copyright_name: "Ole Petter Kyrkjebø Hjønnevåg"
}